import { Resend } from 'resend';

let clientInstance = null;

/**
 * Servicio unificado de correo electrónico para Bryemma usando Resend
 */
export const emailService = {
  /**
   * Obtener instancia de cliente Resend
   */
  getClient() {
    if (!clientInstance) {
      const apiKey = process.env.REACT_APP_RESEND_API_KEY || process.env.RESEND_API_KEY || 're_fCXVvSqU_JarLJr3Gd4fQp4AvxPjAW5i7';
      clientInstance = new Resend(apiKey);
    }
    return clientInstance;
  },

  /**
   * Configurar cliente personalizado (útil para testing)
   */
  setClient(customClient) {
    clientInstance = customClient;
  },

  /**
   * Enviar un correo electrónico personalizado
   * @param {Object} options Options for sending email
   * @param {string} options.to Email destinatario
   * @param {string} [options.subject] Asunto del correo
   * @param {string} [options.html] Contenido HTML del correo
   * @param {string} [options.from] Remitente (por defecto soporte@bryemma.com o onboarding@resend.dev)
   */
  async sendEmail({ to, subject = 'Notificación de Bryemma', html, from = 'soporte@bryemma.com' }) {
    try {
      const resend = this.getClient();
      const response = (await resend.emails.send({
        from,
        to: Array.isArray(to) ? to : [to],
        subject,
        html: html || '<p>Gracias por usar Bryemma.</p>'
      })) || {};
      
      if (response.error) {
        return { success: false, error: response.error };
      }
      
      const emailData = response.data !== undefined ? response.data : response;
      return { success: true, data: emailData };
    } catch (error) {
      console.error('Error al enviar correo electrónico con Resend:', error);
      return { success: false, error: error.message || error };
    }
  },

  /**
   * Enviar correos del área de Soporte Técnico
   */
  async sendSupportEmail({ to, subject, html }) {
    return this.sendEmail({ from: 'Soporte Bryemma <soporte@bryemma.com>', to, subject, html });
  },

  /**
   * Enviar correos del área Legal / Términos
   */
  async sendLegalEmail({ to, subject, html }) {
    return this.sendEmail({ from: 'Legal Bryemma <legal@bryemma.com>', to, subject, html });
  },

  /**
   * Enviar correos de Notificaciones de Servicios y Envíos
   */
  async sendNotificationEmail({ to, subject, html }) {
    return this.sendEmail({ from: 'Notificaciones Bryemma <notificaciones@bryemma.com>', to, subject, html });
  },

  /**
   * Enviar correos dirigidos a Conductores
   */
  async sendDriverEmail({ to, subject, html }) {
    return this.sendEmail({ from: 'Conductores Bryemma <conductores@bryemma.com>', to, subject, html });
  },

  /**
   * Enviar correo de prueba inicial
   * @param {string} [targetEmail] Correo destino
   */
  async sendTestEmail(targetEmail = 'bryemma26@gmail.com') {
    return this.sendEmail({
      to: targetEmail,
      subject: 'Prueba Inicial de Correo — Bryemma',
      html: `
        <div style="font-family: Arial, sans-serif; padding: 20px; color: #0f172a; max-width: 600px; margin: 0 auto; border: 1px solid #e2e8f0; border-radius: 12px;">
          <h2 style="color: #0EABB0; margin-top: 0;">¡Conexión Exitosa con Resend! 🚀</h2>
          <p>Hola, este es un correo de prueba automático enviado desde la plataforma <strong>Bryemma</strong>.</p>
          <p>Tu servicio de correo ya está integrado correctamente y listo para notificaciones de viajes, envíos y registros.</p>
          <hr style="border: none; border-top: 1px solid #e2e8f0; margin: 20px 0;" />
          <p style="font-size: 0.85rem; color: #64748b;">Enviado desde Bryemma App • El Tigre, Anzoátegui, Venezuela.</p>
        </div>
      `
    });
  }
};

export default emailService;
